export enum SortProps {
  ProviderAsc = 'providerAsc',
  ProviderDesc = 'providerDesc',
  AmountAsc = 'amountAsc',
  AmountDesc = 'amountDesc',
  DueAsc = 'dueAsc',
  DueDesc = 'dueDesc',
  StatusAsc = 'statusAsc',
  StatusDesc = 'statusDesc',
}

export enum SortPropsTitle {
  Provider = 'Provider',
  Amount = 'Amount',
  Due = 'Due',
  Status = 'Status',
}

export enum BillsStatus {
  UNVERIFIED = 'Unverified',
  QUERY = 'Queried',
  USER_APPROVAL = 'Review',
  PENDING_PAYMENT = 'To be paid',
  PAID = 'Paid',
  HISTORICAL = 'Paid'
}
